import React from 'react'

const UserGuideComponent = ({pdfUrl}) => {
  return (
    <div>
        <iframe
      src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
      width="100%"
      height="600px"
      style={{ border: "none" }}
    ></iframe>
    </div>
  )
}

export default UserGuideComponent